module.exports = __webpack_public_path__ + "static/media/imgChat.eaf9d14e.svg";